import DOMPurify from "dompurify"

export function sanitize(value: string) {
  return DOMPurify.sanitize(value, { ADD_ATTR: ['target'], FORBID_ATTR: ['style'], FORBID_TAGS: ['style'] })
}
